"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSceneModelRepo = exports.SceneModelRepo = void 0;
const MemoizedBoolean_1 = require("./MemoizedBoolean");
const MemoizedString_1 = require("./MemoizedString");
const ObservableEntityRepo_1 = require("./ObservableEntityRepo");
class SceneModelRepo extends ObservableEntityRepo_1.ObservableEntityRepo {
}
exports.SceneModelRepo = SceneModelRepo;
function makeSceneModelRepo() {
    return new SceneModelRepoImp();
}
exports.makeSceneModelRepo = makeSceneModelRepo;
class SceneModelRepoImp extends SceneModelRepo {
    constructor() {
        super(...arguments);
        this.memoizedActiveModelID = new MemoizedString_1.MemoizedString("", this.notify);
        this.memoizedIsLoading = new MemoizedBoolean_1.MemoizedBoolean(false, this.notify);
    }
    modelLoader( /*modelID: string*/) {
        return Promise.reject(new Error(`SceneModelRepo function modelLoader has not been injected`));
    }
    dataLoader( /*dataID: string*/) {
        return Promise.reject(new Error(`SceneModelRepo function dataLoader has not been injected`));
    }
    get activeModelID() {
        return this.memoizedActiveModelID.val;
    }
    set activeModelID(id) {
        if (!this.has(id)) {
            console.warn("[SceneModelRepo] Unknown Model ID ", id);
            return;
        }
        this.memoizedActiveModelID.val = id;
    }
    get isLoadingSceneModel() {
        return this.memoizedIsLoading.val;
    }
    set isLoadingSceneModel(val) {
        this.memoizedIsLoading.val = val;
    }
    clearActiveModel() {
        this.memoizedActiveModelID.val = "";
    }
    get activeModel() {
        return this.get(this.memoizedActiveModelID.val);
    }
}
